import styled from 'styled-components';
export var PropertySettings = styled.div.withConfig({
  displayName: "ExtractionPropertiesstyles__PropertySettings",
  componentId: "keen-query-creator__sc-1dsb5hw-0"
})(["&&&{margin-right:10px;margin-bottom:10px;}&&&[draggable='true'] .drag-handle{cursor:grabbing;}&&&:last-child{margin-right:0;}"]);
export var Heading = styled.div.withConfig({
  displayName: "ExtractionPropertiesstyles__Heading",
  componentId: "keen-query-creator__sc-1dsb5hw-1"
})(["&&&{display:flex;align-items:center;}"]);
export var SortableContainer = styled.div.withConfig({
  displayName: "ExtractionPropertiesstyles__SortableContainer",
  componentId: "keen-query-creator__sc-1dsb5hw-2"
})(["&&&{display:flex;flex-wrap:wrap;}"]);
export var Wrapper = styled.div.withConfig({
  displayName: "ExtractionPropertiesstyles__Wrapper",
  componentId: "keen-query-creator__sc-1dsb5hw-3"
})(["&&&{position:relative;display:inline-block;}"]);